import React, { useCallback, useEffect } from "react";
import { useState } from "react";
import { useBeforeUnload } from "react-router-dom";
import { useQueue, useUpdateEffect } from "react-use";
import { layers, Portal, ToastMessage, SlideFromTop } from "@activecollab/components";
import PropTypes from "prop-types";
import styles from "./ToastContainer.module.css";
import { SHOW_TOAST_EVENT } from "./index.js";

export const ToastContainer = ({ className }) => {
  const { add, remove, first, size } = useQueue();
  const [open, setOpen] = useState(size > 0);
  const close = useCallback(() => setOpen(false), []);

  // trying to fix NetworkError when attempting to fetch resource exception when redirecting in Firefox
  useBeforeUnload(close);

  useEffect(() => {
    const handleShowToast = (event) => {
      add({ ...event.detail });
    };

    window.addEventListener(SHOW_TOAST_EVENT, handleShowToast);

    return () => {
      window.removeEventListener(SHOW_TOAST_EVENT, handleShowToast);
    };
  }, [add]);

  useUpdateEffect(() => {
    setOpen(size > 0);
  }, [size, first]);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  const handleExit = useCallback(() => {
    if (typeof first?.onClose === "function") {
      first?.onClose();
    }
    remove();
  }, [first, remove]);

  return (
    <Portal>
      <SlideFromTop
        in={open}
        initialDirection="top"
        onExited={handleExit}
      >
        <ToastMessage
          type={first?.type}
          text={first?.message}
          onClose={handleClose}
          timeout={first?.timeout}
          dismissible={first?.dismissible}
          className={[styles.toast, className]}
          style={{
            zIndex: layers.cloud,
          }}
        />
      </SlideFromTop>
    </Portal>
  );
};

ToastContainer.propTypes = {
  className: PropTypes.string,
};
